
export const SCREEN_WIDTH = 480;
export const SCREEN_HEIGHT = 320;